<mat-form-field appearance="outline"
                floatLabel="always"
                id="select-component-root"
                [ngClass]="{small, 'v2-select': v2}"
                [hideRequiredMarker]="v2">
  <mat-label *ngIf="!this.hideLabel">{{label}}</mat-label>
  <mat-select [formControl]="control"
              disableOptionCentering
              panelClass="panel-options"
              [value]="value"
              (selectionChange)="changeSelect()"
              id="select"
              [ngClass]="{'v2-select': v2}"
              [placeholder]="placeholder"
              [disabled]="disabled"
              [compareWith]="optionCompareFn"
              [multiple]="isMultiSelect"
              #select
              v2>
    <mat-option *ngFor="let option of options"
                [value]="option"
                (click)="handleOpenChange()">
      {{getOption(option)}}
    </mat-option>
  </mat-select>
  <div matSuffix>
    <mat-icon class="select-icon-less">expand_less</mat-icon>
  </div>
  <mat-error>{{errorMessage}}</mat-error>
</mat-form-field>
